import React,{ useState } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import './index.css';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';

function WriteExperience({ data, baseURL, setPage }) {
  const navigate = useNavigate();
  const { templateid, contactid } = useParams();
  const [experienceData, setExperienceData] = useState('');
  const [showError, setShowError] = useState(false);
  const [willingContacted, setWillingContacted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorMsg, setErrorMsg] = useState('');
  
  const SendReview = async () => {
    const putbody = {
      experience: experienceData,
      willing_contacted: willingContacted,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/testing/contact-us/${templateid}/${contactid}`,
        putbody,
      );
      console.log(response, 'this review post');
      if (response.data.status === 'success') {
        //   setData(response?.data?.data);
        setPage(3);
        setLoading(false);
      }
      if (response.data.status === 'failure') {
        //   setData(response?.data?.data);
        // setPage(3);
        setShowError(true);
        setErrorMsg(response.data.message);

        // setLoading(false);
      }
      // navigate(`/reviewus/${templateid}/${contactid}`)
      // if(response === 'success'){
      //   navigate('/reviewus/:template_id/:contact_id')
      // }else{
      //   throw new Error('Could not routing')
      // }
    } catch (error) {
      console.log(error, 'error');
      setShowError(true);
      setErrorMsg(error.response.data.error);
    }
  };
  return (
    <div className="qs-fade-in space-y-5">
      <div className="qs-title flex justify-center">
        <p>{data?.template.feedback_page_message}</p>
      </div>
      <div>
        <textarea
          className="qs-input min-h-[160px] resize-y"
          placeholder="Tell us about your experience"
          value={experienceData}
          onChange={(e) => setExperienceData(e.target.value)}
        />
      </div>

      <div className="flex w-full justify-center text-slate-600">
        {data?.template?.feedback_callback_requestion_flag && (
          <FormControlLabel
            sx={{ '& .MuiFormControlLabel-label': { fontFamily: 'inherit', fontSize: '14px', color: '#475569' } }}
            control={(
              <Checkbox
                checked={willingContacted}
                onChange={(e) => setWillingContacted(e.target.checked)}
              />
                )}
            label={data.template.feed_back_callback_message}
          />
        )}            
      </div>

      {showError ? (
        <p className="show-error rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-center text-sm text-red-600">
          {errorMsg}
        </p>
      ) : null}

      <div className="flex justify-center pt-1">
        <button
          type="button"
          disabled={experienceData?.length < 4 || loading}
          // style={{
          //   // width: '100%',
          //   backgroundColor:
          //       experienceData?.length < 4 
          //         ? 'RGB(233, 233, 235)'
          //         : '#1976d2',
          //   marginLeft: '45px' ,
          //   marginBottom: '8px',
          // }}
          className="qs-btn qs-btn-primary sm:w-1/2"
          onClick={SendReview}
        >
          Submit
        </button>
      </div>

    </div>
  );
}

export default WriteExperience;
